var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrajetriaPoltica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trajet\xC3\xB3ria Pol\xC3\xADtica"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.2292 16.2565L27.2712 11.2976C26.8461 11.0146 26.2793 11.0855 25.9252 11.4395C25.5712 11.7936 25.5002 12.3605 25.7833 12.7855L28.9357 15.9372H25.1462C24.1542 15.9372 23.0921 15.9726 21.9583 15.9726C15.7962 16.0791 6.44615 16.221 4.88733 12.6791C4.63972 12.1476 4.03734 11.9 3.47116 12.1476C2.93973 12.396 2.6921 12.9976 2.93971 13.5645C4.74615 17.6024 11.5461 18.1686 18.1333 18.1686C19.4438 18.1686 20.7542 18.1331 21.9938 18.1331C23.1276 18.0976 24.1897 18.0976 25.1462 18.0976H28.9712L25.8188 21.25C25.5002 21.675 25.5357 22.2774 25.8897 22.6669C26.2438 23.0565 26.8816 23.0919 27.3066 22.7379L32.2647 17.7791C32.3712 17.6726 32.4421 17.567 32.4776 17.425C32.4776 17.3896 32.5123 17.3541 32.5123 17.3186C32.5123 17.2831 32.5123 17.2831 32.5478 17.2476C32.5478 17.2129 32.5478 17.1774 32.5478 17.1419C32.5478 17.1065 32.5478 17.071 32.5478 17.0355C32.5478 17 32.5478 17 32.5478 16.9646C32.5123 16.6815 32.4066 16.4331 32.2292 16.2565Z",
    fill: "#FFC000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrajetriaPoltica);
export default __webpack_public_path__ + "static/media/Trajetória Política.7686c19e7ab2a46c09a6fcbbd3dc6dcf.svg";
export { ForwardRef as ReactComponent };